import React from 'react';
import '../styles/Instructions.css';

function Instructions() {
  return (
    <>
      <div className="instructions">
        Find today's mystery Skylander. New character every day at midnight!
      </div>

      <div className="legend">
        <div className="legend-item">
          <div className="legend-box correct"></div>
          <span>Correct</span>
        </div>
        <div className="legend-item">
          <div className="legend-box partial"></div>
          <span>Related Element</span>
        </div>
        <div className="legend-item">
          <div className="legend-box incorrect"></div>
          <span>Incorrect</span>
        </div>
      </div>
    </>
  );
}

export default Instructions;
